import { Reasoning } from "src/app/model/reasoning/Reasoning";
import { createReducer, on } from "@ngrx/store";
import * as ReasoningActions from "./reasoning.actions";

export interface ReasoningState {
    entries: Reasoning[];
}

const initialReasoningState: ReasoningState = {
    entries: [],
};

export const reasoningReducer = createReducer(
    initialReasoningState,
    on(ReasoningActions.updateReasoning, (state, { entry }) => ({
        ...state,
        entries: [
            ...state.entries.filter(
                (e) => e.reasoningType !== entry.reasoningType,
            ),
            entry,
        ],
    })),
    on(ReasoningActions.clearReasonings, () => initialReasoningState),
);
